import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../shadcn-ui/card';

const HomeOptionButton = ({ icon: Icon, title, to, disabled }) => {
  return (
    <Link to={disabled ? '#' : to} className="block w-full h-[120px] rounded-xl">
      <Card className="h-full w-full flex items-center justify-center">
        <CardContent className="flex flex-col items-center justify-center p-[22px]">
          <Icon className="w-8 h-8 text-foreground" />
          <div className="mt-[18px] text-foreground text-sm font-medium md:text-base">{title}</div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default HomeOptionButton;
